export const Routes = {
  LOGIN: '/',
  SIGN_UP: '/signup',
  SIGN_UP_PLUGIN: '/plugin/signup/:lang',
  HOME: '/home',
  REPORTS: '/reports',
  ACTIVATE_ACCOUNT: '/activate-account',
  EMAIL_VALIDATION: '/email-validation',
  CONFIRM_EMAIL: '/user/confirm_email',
  PAYMENT_METHODS: '/payment-methods',
  MOVEMENTS: '/movements',
  CHARGES: '/charges',
  TRANSACTIONS: '/transactions',
  TRANSACTION_DETAIL: '/transactions/:invoice_id/detail',
  TRANSACTIONS_AFFILIATIONS: '/transactions/affiliations',
  TRANSACTIONS_STATEMENT: '/transactions/statement',
  SETTLEMENTS: '/settlements',
  PAYMENT_LINK: '/payment-link',
  CREATE_ONE_TIME_PAYMENT_LINK: '/payment-link/create',
  CREATE_RECURRING_PAYMENT_LINK: '/payment-link/create/recurring',
  CREATED_PAYMENT_LINKS: '/payment-link/created',
  ONE_TIME_PAYMENT_LINK: '/payment-link/one-time',
  RECURRING_PAYMENT_LINK: '/payment-link/recurring',
  OPEN_PAYMENT_LINK: '/payment-link/open',
  QR_PAYMENT: '/payment-link/qr',
  // TODO: Pago inteligente aún no existe como producto.
  SMART_PAYMENT: '/#',
  CHECKOUT_THEMES: '/checkout-themes',
  VIRTUAL_POS: '/virtual-pos',
  MARKETING: '/marketing',
  MARKETING_CAMPAIGNS: '/marketing/campaigns',
  PAYMENT_BUTTON: '/payment-button',
  PAYMENT_INTEGRATION: '/payment-integration',
  NOT_FOUND: '/not-found',
  COMPANY_INFORMATION: '/company-information',
  REVIEW_DOCUMENTATION: '/company-information/review-documentation',
  REFUNDS: '/refunds',
  REFUND_DETAIL: '/refunds/:invoice_id/detail',
  PAY: '/pay',
  PAYOUTS: '/payouts',
  PAYOUT_CONTACTS: '/payouts/contacts',
  PAYOUT_CONTACT_DETAIL: '/payouts/contacts/:contact_id/detail',
  PAYOUT_CONTACT_CREATE: '/payouts/contacts/create',
  PAYOUT_CONTACT_BANK_ACCOUNT_CREATE: '/payouts/contacts/:beneficiary_id/bank-accounts/create',
  PAYOUT_CONTACT_BANK_ACCOUNT_EDIT: '/payouts/contacts/:beneficiary_id/bank-accounts/:account_id/edit',
  PAYOUTS_STEP_ACCOUNT_DATA: '/payouts/create/step/account-data',
  PAYOUTS_STEP_PAYOUT_DATA: '/payouts/create/step/payout-data',
  PAYOUTS_STEP_REVIEW: '/payouts/create/step/review',
  PAYOUTS_ADD_BENEFICIARY: '/payouts/beneficiaries/create',

  PASSWORD_RESET: '/password-reset',
  USER_PASSWORD_RESET: '/user/password-reset',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:client_id/detail',
  BANK_ACCOUNTS: '/bank-accounts',
  CHARGEBACKS: '/chargebacks',
  CHARGEBACK_DETAIL: '/chargebacks/:external_id/detail',
  SUBSCRIPTIONS: '/subscriptions',
  SUBSCRIPTIONS_PLANS: '/subscriptions/plans',
  SUBSCRIPTIONS_DETAIL: '/subscriptions/detail',
  SUBSCRIPTIONS_PLANS_DETAILS: '/subscriptions/plans/details',
  SUBSCRIPTIONS_PLANS_CREATE: '/subscriptions/plans/create',
  SUBSCRIPTIONS_PLANS_EDIT: '/subscriptions/plans/:id/edit',
  SPLIT_PAYMENTS: '/split-payments',
  SPLIT_PAYMENTS_RESUME: '/split-payments/resume/:collaboration_id',
  SPLIT_PAYMENTS_STEP_USER_TYPE: '/split-payments/create/step/user-type',
  SPLIT_PAYMENTS_STEP_INFORMATION: '/split-payments/create/step/information',
  SPLIT_PAYMENTS_STEP_RESUME: '/split-payments/create/step/resume',
  USER_MANAGEMENT: '/user-management',
  INVITATION_PASSWORD: '/user/invitation-password',
  PROFILE: '/profile',
  PROFILE_PERSONAL_INFO: '/profile/personal-information',
  PROFILE_SECURITY: '/profile/security',
};
